import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import WordleListPage from 'src/pages/main-dashboard/games/wordle';
// import WordAssociationListPage from 'src/pages/main-dashboard/games/word-association';
// import BrainFlipListPage from 'src/pages/main-dashboard/games/brain-flip';
// import HangmanListPage from 'src/pages/main-dashboard/games/hangman';
// import LanguagesPage from 'src/pages/main-dashboard/languages/languages';
// import FaqPage from 'src/pages/main-dashboard/faq/faq-page';
// import AboutUsPage from 'src/pages/main-dashboard/about-us/about-us-page';
// import PrivacyPolicyPage from 'src/pages/main-dashboard/privacy-policy/privacy-policy-page';
// import SupportPage from 'src/pages/main-dashboard/support/support-page';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));
// // PRODUCT
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));
// APP
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const MailPage = lazy(() => import('src/pages/dashboard/mail'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'));
// TEST RENDER PAGE BY ROLE
// const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));
const UsersProfilePage = lazy(() => import('src/pages/main-dashboard/users/profile'));
const UsersListPage = lazy(() => import('src/pages/main-dashboard/users/list')); 
const CategoriesProfilePage = lazy(() => import('src/pages/main-dashboard/categories/profile'));
const CategoriesListPage = lazy(() => import('src/pages/main-dashboard/categories/categories-page'));
const TacPage = lazy(() => import('src/pages/main-dashboard/terms-and-conditions/tac-page'));
const LanguagesPage = lazy(() => import('src/pages/main-dashboard/languages/languages'));
const GamesPage = lazy(() => import('src/pages/main-dashboard/games/games'));
const FaqPage = lazy(() => import('src/pages/main-dashboard/faq/faq-page'));
const AboutUsPage = lazy(() => import('src/pages/main-dashboard/about-us/about-us-page'));
const PrivacyPolicyPage = lazy(() => import('src/pages/main-dashboard/privacy-policy/privacy-policy-page'));
const SupportPage = lazy(() => import('src/pages/main-dashboard/support/support-page'));
const CategoriesLevelPage = lazy(() => import('src/pages/main-dashboard/categories/levels'));
const WordAssociationListPage = lazy(() => import('src/pages/main-dashboard/games/word-association'));
const WordleListPage = lazy(() => import('src/pages/main-dashboard/games/wordle')); 
const BrainFlipListPage = lazy(() => import('src/pages/main-dashboard/games/brain-flip'));
const HangmanListPage = lazy(() => import('src/pages/main-dashboard/games/hangman'));
const LevelsListPage = lazy(() => import('src/pages/main-dashboard/levels/levels'));



// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
       </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },

      // { path: 'customers', element: <CustomersPage /> },
      { path: 'languages', element: <LanguagesPage /> },
      // { path: 'games', element: <GamesPage /> },
      // { path: 'bookings', element: <BookingsPage /> },
      { path: 'faq', element: <FaqPage /> },
      { path: 'about-us', element: <AboutUsPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'support', element: <SupportPage /> },
      { path: 'terms-and-conditions', element: <TacPage />},

      // OTHER PAGES
      { path: 'ecommerce', element: <OverviewEcommercePage /> },
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'banking', element: <OverviewBankingPage /> },
      { path: 'booking', element: <OverviewBookingPage /> },
      { path: 'file', element: <OverviewFilePage /> },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
      {
        path: 'users',
        children: [
          { element: <UsersListPage />, index: true },
          { path: 'profile/:id', element: <UsersProfilePage /> },
          { path: 'list', element: <UsersListPage /> },
        ],
      },
      {
        path: 'levels',
        children: [{ element: <LevelsListPage />, index: true }],
      },
      {
        path: 'categories',
        children: [
          { element: <CategoriesListPage />, index: true },
          { path: 'profile/:id', element: <CategoriesProfilePage /> },
          { path: 'levels/:id', element: <CategoriesLevelPage /> },
          { path: 'list', element: <CategoriesListPage /> },
        ],
      },
      {
        path: 'games',
        children: [
          { element: <WordleListPage />, index: true },
          { path: 'wordle', element: <WordleListPage /> },
          { path: 'word-association', element: <WordAssociationListPage /> },
          { path: 'brain-flip', element: <BrainFlipListPage /> },
          { path: 'hangman', element: <HangmanListPage /> },
        ],
      },
      { path: 'file-manager', element: <FileManagerPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'kanban', element: <KanbanPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];
